<div mat-dialog-title>Preset configuration</div>
<mat-dialog-content class="preset-config-dialog">
    <mat-tab-group class="preset-tab-group">
        <mat-tab label="Filter">
            <ng-template mat-tab-label>
                <span [attr.data-uiid]="'preset-config-tab-filter'">Filter</span>
            </ng-template>
            <mat-grid-list rowHeight="fit" cols="2" class="dialog-grid-list">
                <mat-grid-tile>
                    <form
                        [formGroup]="presetRuleForm"
                        #formDirective="ngForm"
                        (ngSubmit)="onAddFilter(formDirective)"
                        class="form-field-group"
                    >
                        <mat-form-field>
                            <mat-label>Column</mat-label>
                            <input
                                type="text"
                                placeholder="Search for column"
                                matInput
                                required
                                formControlName="column"
                                [matAutocomplete]="auto"
                                [attr.data-uiid]="'preset-config-column-input'"
                            />
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                [displayWith]="displayColumnText.bind(this)"
                                (optionSelected)="onSelectedColumn($event.option.value, false)"
                                [attr.data-uiid]="'preset-config-column-autocomplete'"
                                autoActiveFirstOption
                            >
                                @for (
                                    column of filteredColumns$ | async;
                                    track column;
                                    let i = $index
                                ) {
                                    <mat-option
                                        [attr.data-uiid]="'preset-config-column-option-' + i"
                                        [value]="column"
                                        >{{
                                            column.translation ??
                                                incidentColumnsTranslation.get(column.name)
                                        }}</mat-option
                                    >
                                }
                            </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Compare with</mat-label>
                            <mat-select
                                formControlName="comparisonOperator"
                                [attr.data-uiid]="'preset-config-comparison-select'"
                            >
                                @for (
                                    comparisonOperator of filteredComparisonOperators$ | async;
                                    track comparisonOperator;
                                    let i = $index
                                ) {
                                    <mat-option
                                        [value]="comparisonOperator"
                                        [attr.data-uiid]="'preset-config-comparison-option-' + i"
                                        >{{ comparisonOperator.name }}</mat-option
                                    >
                                }
                            </mat-select>
                        </mat-form-field>

                        @if (treeColumnNames.includes(presetRuleForm.get("column").value?.name)) {
                            <cerrix-tree-select
                                formControlName="searchValue"
                                [treeList]="ruleSearchOptions"
                                [multiple]="true"
                                [dataUiid]="'preset-config-search-value-tree-select'"
                            ></cerrix-tree-select>
                        } @else {
                            @switch (presetRuleForm.get("column").value?.fieldType) {
                                @case (FieldType.Numeric) {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        <input
                                            [attr.data-uiid]="'preset-config-search-value-input'"
                                            type="number"
                                            matInput
                                            formControlName="searchValue"
                                        />
                                    </mat-form-field>
                                }
                                @case (FieldType.Date) {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        <input
                                            matInput
                                            [attr.data-uiid]="
                                                'preset-config-search-value-date-input'
                                            "
                                            [matDatepicker]="datepicker"
                                            formControlName="searchValue"
                                            [placeholder]="dateFormats.display.dateInput"
                                        />
                                        <mat-datepicker-toggle
                                            matIconSuffix
                                            [for]="datepicker"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                    </mat-form-field>
                                }
                                @case (FieldType.DateTime) {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        <input
                                            matInput
                                            [attr.data-uiid]="
                                                'preset-config-search-value-date-input'
                                            "
                                            [matDatepicker]="datepicker"
                                            formControlName="searchValue"
                                            [placeholder]="dateFormats.display.dateInput"
                                        />
                                        <mat-datepicker-toggle
                                            matIconSuffix
                                            [for]="datepicker"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                    </mat-form-field>
                                }
                                @case (FieldType.Checkbox) {
                                    <mat-checkbox
                                        formControlName="searchValue"
                                        [attr.data-uiid]="'preset-config-search-value-checkbox'"
                                    >
                                        >value should be</mat-checkbox
                                    >
                                }
                                @case (FieldType.SingleSelect) {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        @if (loadingRuleSearchOptions) {
                                            <span class="dropdown-spinner"
                                                ><mat-spinner diameter="20"></mat-spinner
                                            ></span>
                                        }

                                        <mat-select
                                            formControlName="searchValue"
                                            [attr.data-uiid]="'preset-config-search-value-select'"
                                            [multiple]="true"
                                        >
                                            @for (
                                                ruleSearchOption of ruleSearchOptions;
                                                track ruleSearchOption;
                                                let i = $index
                                            ) {
                                                <mat-option
                                                    [value]="ruleSearchOption.id"
                                                    [attr.data-uiid]="
                                                        'preset-config-search-value-option-' + i
                                                    "
                                                    >{{ ruleSearchOption.name }}</mat-option
                                                >
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                }
                                @case (FieldType.MultiSelect) {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        @if (loadingRuleSearchOptions) {
                                            <span class="dropdown-spinner"
                                                ><mat-spinner diameter="20"></mat-spinner
                                            ></span>
                                        }

                                        <mat-select
                                            formControlName="searchValue"
                                            [attr.data-uiid]="'preset-config-search-value-select'"
                                            [multiple]="true"
                                        >
                                            @for (
                                                ruleSearchOption of ruleSearchOptions;
                                                track ruleSearchOption;
                                                let i = $index
                                            ) {
                                                <mat-option
                                                    [value]="ruleSearchOption.id"
                                                    [attr.data-uiid]="
                                                        'preset-config-search-value-option-' + i
                                                    "
                                                    >{{ ruleSearchOption.name }}</mat-option
                                                >
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                }
                                @default {
                                    <mat-form-field>
                                        <mat-label>Search value</mat-label>
                                        <input
                                            type="text"
                                            matInput
                                            [attr.data-uiid]="
                                                'preset-config-search-value-default-input'
                                            "
                                            formControlName="searchValue"
                                        />
                                    </mat-form-field>
                                }
                            }
                        }

                        <div class="add-filter-actions">
                            <button
                                type="submit"
                                [attr.data-uiid]="'preset-config-add-filter-button'"
                                mat-stroked-button
                            >
                                <ng-container>Add filter</ng-container
                                ><mat-icon iconPositionEnd>arrow_right</mat-icon>
                            </button>
                        </div>
                    </form>
                </mat-grid-tile>
                <mat-grid-tile>
                    @if (presetRules.length) {
                        <div class="added-filters">
                            <mat-chip-listbox>
                                @for (rule of presetRules; track rule; let i = $index) {
                                    <mat-chip-option
                                        (removed)="onRemoveFilter(rule)"
                                        (click)="onEditFilter(rule)"
                                    >
                                        {{
                                            rule.customFieldId
                                                ? rule.columnName
                                                : incidentColumnsTranslation.get(rule.columnName)
                                        }}
                                        {{
                                            comparisonOperatorsTranslation.get(
                                                rule.comparisonOperator
                                            )
                                        }}
                                        @if (
                                            rule.fieldType === FieldType.Date ||
                                            rule.fieldType === FieldType.DateTime
                                        ) {
                                            {{ rule.value | dateTimeDisplay }}
                                        } @else {
                                            {{ rule.displayValue ?? rule.value }}
                                        }
                                        <button
                                            matChipRemove
                                            [attr.data-uiid]="
                                                'preset-config-remove-filter-button-' + i
                                            "
                                        >
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        </div>
                    } @else {
                        <div>
                            <div>No filters specified.</div>
                        </div>
                    }
                </mat-grid-tile>
            </mat-grid-list>
        </mat-tab>
        <mat-tab label="Columns">
            <ng-template mat-tab-label>
                <span [attr.data-uiid]="'preset-config-tab-columns'">Columns</span>
            </ng-template>
            <mat-grid-list rowHeight="fit" cols="2" class="dialog-grid-list" cdkDropListGroup>
                <mat-grid-tile>
                    <div class="columns-drop-container">
                        <div class="columns-drop-header">Visible columns</div>
                        <div
                            cdkDropList
                            #visibleList="cdkDropList"
                            [cdkDropListData]="visibleColumns"
                            [cdkDropListConnectedTo]="[hiddenList]"
                            class="columns-drop-list"
                            (cdkDropListDropped)="onDropColumn($event, true)"
                            cdkScrollable
                        >
                            @for (column of visibleColumns; track column; let i = $index) {
                                <div
                                    class="colum-drop-box"
                                    cdkDrag
                                    [cdkDragPreviewContainer]="'parent'"
                                    matRipple
                                    [attr.data-uiid]="'preset-config-visible-column-' + i"
                                    (click)="onColumToggle(column, false)"
                                >
                                    {{
                                        column.translation
                                            ? column.translation
                                            : incidentColumnsTranslation.get(column.name)
                                    }}
                                </div>
                            }
                        </div>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="columns-drop-container">
                        <div class="columns-drop-header">Hidden columns</div>
                        <div
                            cdkDropList
                            #hiddenList="cdkDropList"
                            [cdkDropListData]="hiddenColumns"
                            [cdkDropListConnectedTo]="[visibleList]"
                            class="columns-drop-list"
                            (cdkDropListDropped)="onDropColumn($event, false)"
                            cdkScrollable
                        >
                            @for (column of hiddenColumns; track column; let i = $index) {
                                <div
                                    class="colum-drop-box"
                                    cdkDrag
                                    [cdkDragPreviewContainer]="'parent'"
                                    matRipple
                                    [attr.data-uiid]="'preset-config-hidden-column-' + i"
                                    (click)="onColumToggle(column, true)"
                                >
                                    {{
                                        column.translation
                                            ? column.translation
                                            : incidentColumnsTranslation.get(column.name)
                                    }}
                                </div>
                            }
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </mat-tab>
        <mat-tab label="Details">
            <ng-template mat-tab-label>
                <span [attr.data-uiid]="'preset-config-tab-details'">Details</span>
                @if (dataLoaded && !presetDetailsForm.valid) {
                    <span class="invalid-message">*</span>
                }
            </ng-template>
            <mat-grid-list rowHeight="fit" cols="2" class="dialog-grid-list">
                <mat-grid-tile>
                    <form [formGroup]="presetDetailsForm" class="form-field-group">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input
                                type="text"
                                matInput
                                formControlName="name"
                                [attr.data-uiid]="'preset-config-details-name-input'"
                            />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Icon</mat-label>
                            <input
                                type="text"
                                matInput
                                formControlName="icon"
                                [attr.data-uiid]="'preset-config-details-icon-input'"
                            />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <textarea
                                rows="3"
                                matInput
                                formControlName="description"
                                [attr.data-uiid]="'preset-config-details-description-textarea'"
                            ></textarea>
                        </mat-form-field>

                        <mat-checkbox
                            formControlName="isFavorite"
                            [attr.data-uiid]="'preset-config-details-favorite-checkbox'"
                            >Is favorite</mat-checkbox
                        >
                    </form>
                </mat-grid-tile>
                <mat-grid-tile></mat-grid-tile>
            </mat-grid-list>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'" class="footer">
    <div>
        @if (dataLoaded && !(presetRules?.length > 0) && !hasColumnsChanges) {
            <span class="invalid-message"
                >Please add at least one rule or make one column change.</span
            >
        }

        <div>
            <button
                mat-stroked-button
                [mat-dialog-close]="true"
                [attr.data-uiid]="'preset-config-cancel-button'"
            >
                <mat-icon>close</mat-icon>
                <ng-container>Cancel</ng-container>
            </button>
            <button
                [disabled]="!(presetRules?.length > 0) && !hasColumnsChanges"
                [attr.data-uiid]="'preset-config-preview-button'"
                mat-stroked-button
                (click)="onApplyPreset()"
            >
                <mat-icon>check</mat-icon>
                <ng-container>Preview preset</ng-container>
            </button>
            <button
                [disabled]="saveDisabled || (!(presetRules?.length > 0) && !hasColumnsChanges)"
                [attr.data-uiid]="'preset-config-save-button'"
                mat-stroked-button
                (click)="onSavePreset()"
            >
                <mat-icon>save</mat-icon>
                <ng-container>Save preset</ng-container>
            </button>
        </div>
    </div>
</mat-dialog-actions>
